import { Options } from 'highcharts/highstock';
import { ChartDatum } from 'funds-model';

export interface FundSmallChartColors {
  lineColor: string;
  backgroundColor: string;
}

export function buildSmallChartOptions(
  height: number,
  width: number | null,
  data: ChartDatum[],
  colors: FundSmallChartColors,
): Options {
  const yAxisValues = data.map(({ y }) => y);
  const yAxisMinValue = Math.min(...yAxisValues);
  const yAxisMaxValue = Math.max(...yAxisValues);

  return {
    chart: {
      backgroundColor: colors.backgroundColor,
      height,
      width: width ?? undefined,
      spacing: [2, 0, 2, 0],
    },
    series: [{
      type: 'spline',
      data,
      marker: { enabled: false },
      enableMouseTracking: false,
      color: colors.lineColor,
      turboThreshold: 0,
      lineWidth: 1.5,
    }],
    legend: { enabled: false },
    title: { text: '' },
    yAxis: { visible: false, min: yAxisMinValue, max: yAxisMaxValue },
    xAxis: { visible: false, tickLength: 0 },
    tooltip: { enabled: false },
    credits: { enabled: false },
    navigator: { enabled: false },
    rangeSelector: { enabled: false },
    scrollbar: { enabled: false },
  };
}
